export const PAY_CYCLE_LOADING = "[PAY CYCLE] PAY_CYCLE_LOADING";
export const PAY_CYCLE_SUCCESS = "[PAY] PAY_CYCLE_SUCCESS";
export const PAY_CYCLE_FAILED = "[PAY] PAY_CYCLE_FAILED";
